import React from 'react';
import  { useState, useRef, useCallback } from 'react';
import  { useEffect }from 'react';


import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import Grid from '@mui/material/Unstable_Grid2';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';

import { DataGrid } from '@mui/x-data-grid';

import { Autocomplete} from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';

import { APIvar } from '../services/variables';
import './Telefon.css'
import { componentStyles } from '../services/elementDesign'
import * as actions from "./redux/actions"

import { APICall } from './services/api.service';
import { useNavigate } from "react-router-dom";


import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const useColor = APIvar.colorUse;
const thirdColor = APIvar.colorTerciary;
const backColor = APIvar.colorBackground;
const cardBackColor = APIvar.cardBackgrounColor;
const formRowGap = APIvar.formRowGap

document.documentElement.style.setProperty('--backColor', backColor);
document.documentElement.style.setProperty('--cardBackColor', cardBackColor);


const theme = createTheme({
  palette: {
    primary: {
      main: '#520074'
    }
  },
});

const Telefoni = () => {


  const dispatch = useDispatch()

  const [vlasnikChecked, setVlasnikChecked] = useState(false);
  const [korisnikChecked, setKorisnikChecked] = useState(false);
  const [selectedOperatorOption, setSelectedOperatorOption] = useState('');
  const [selectedTipOption, setSelectedTipOption] = useState('');
  const [tajniChecked, setTajniChecked] = useState(false);
  const [selectedPrikljucakOption, setSelectedPrikljucakOption] = useState('');

  const [listObjava, setListObjava] = useState([{id:'1',desc:"Normalna"},
  {id:'0',desc:"Nigdje"},
  {id:'9',desc:"Ne u imenik"},
  {id:'7',desc:"Niti imenik, niti CD"},
]);


  const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)


  const prihvatiButtonFunction = () => {
    dispatch(actions.isLoading());
    console.log("Prihvati")
    dispatch(actions.isNotLoading());
  }

  const odustaniButtonFunction = () => {
    dispatch(actions.isLoading());
    console.log("Odustani")
    dispatch(actions.isNotLoading());
  }

  const obrisiButtonFunction = () => {
    dispatch(actions.isLoading());
    console.log("Obrisi")
    dispatch(actions.isNotLoading());
  }

  const krajButtonFunction = () => {
    dispatch(actions.isLoading());
    console.log("Kraj")
    dispatch(actions.isNotLoading());
  }

  const handleVlasnikCheckboxChange = (event) => {
    setVlasnikChecked(event.target.checked);
  };
  const handleKorisnikCheckboxChange = (event) => {
    setKorisnikChecked(event.target.checked);
  };

  const handleSelectOperatorChange = (e) => {
    setSelectedOperatorOption(e.target.value);
  };
  //MOCK DATA
  const operatorOptions = ['Option 1', 'Option 2', 'Option 3'];

  const handleOptionTipClick = (e) => {
    const clickedOption = e.target.value;
    if (selectedTipOption === clickedOption) {
      // If the same radio button is clicked again, uncheck it
      setSelectedTipOption("");
    } else {
      // Otherwise, update the selected option
      setSelectedTipOption(clickedOption);
    }
  };



  const handleSelectPrikljucakChange = (e) => {
    setSelectedPrikljucakOption(e.target.value);
  };
  //MOCK DATA
  const prikljucakOptions = ['Option 1', 'Option 2', 'Option 3'];


  const token = localStorage.getItem("token");


  const navigate = useNavigate();

  //const { user: currentUser } = useSelector((state) => state.auth);
  const user = localStorage.getItem("user");
  const username = localStorage.getItem("username");
  const ref = localStorage.getItem("id");

  const [mreza, setMreza] = useState('');
  const [telefon, setTelefon] = useState('');

  const [vlasnik, setVlasnik] = useState('');
  const [korisnik, setKorisnik] = useState('');

  const [operater, setOperater] = useState({id:'', naziv:''});
  const [naziv1, setNaziv1] = useState('');
  const [naziv2, setNaziv2] = useState('');
  const [naziv3, setNaziv3] = useState('');
  const [titula, setTitula] = useState('');
  const [mjesto, setMjesto] = useState('');
  const [ptt, setPTT] = useState('');
  const [sifra, setSifra] = useState('');
  const [ulica, setUlica] = useState('');
  const [kbr, setKbr] = useState('');
  const [znak, setZnak] = useState('');

  const [tajni, setTajni] = useState('');
  const [obrnuto, setObrnuto] = useState('');
  const [priklj, setPriklj] = useState({naziv:''});
  const [MB, setMB] = useState('');
  const [OIB, setOIB] = useState('');
  const [VPN, setVPN] = useState('');
  const [clip, setClip] = useState('');
  const [sms, setSMS] = useState('');
  const [privremen, setPrivremen] = useState('');
  const [simpaVer, setSimpaVer] = useState('');
  const [objava, setObjava] = useState('');
  const [tipObjava, setTipObjava] = useState('');
  const [selectedObjava, setSelectedObjava] = useState({id:'', desc:''});
  const [komentar, setKomentar] = useState('');



  const [tip1, setTip1] = useState('');
  const [tip2, setTip2] = useState('');
  const [tip3, setTip3] = useState('');
  const [izvTip1, setizvTip1] = useState('');
  const [izvTip2, setizvTip2] = useState('');
  const [izvTip3, setizvTip3] = useState('');

  const [izvMjesto, setIzvMjesto] = useState('');
  const [izvAdresa, setIzvAdresa] = useState('');
  const [izvptt, setIzvPTT] = useState('');
  const [datum, setDatum] = useState('');
  const [tis, setTis] = useState('');

  const [komentDonat, setKomentDonat] = useState('');
  const [web, setWeb] = useState('');
  const [status, setStatus] = useState('');
  const [lastActDonat, setLastActDonat] = useState('');
  const [donatID, setDonatID] = useState('');
  const [NKD, setNKD] = useState('');  
  const [market, setMarket] = useState('');


  const [currentIDFocus, setCurrentIDFocus] = useState(null);
  
  const mreza_ref = useRef(null);
  const tel_ref = useRef(null);

      const mb_ref = useRef(null);
      const oib_ref = useRef(null);
    
      const mjesto_ref = useRef(null);
      const ulica_ref = useRef(null);
      const kbr_ref = useRef(null);
      const kbrZnak_ref = useRef(null);
      const ptt_ref = useRef(null);

      const komentar_ref = useRef(null);
    

      const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const [listUlice, setListUlice] = useState([]);
  const [selectedUlica, setSelectedUlica] = useState({ULICA_ID:'', NAZIV:''});

  
  const [listMjesta, setListMjesta] = useState([]);
  const [selectedMjesto, setSelectedMjesto] = useState({MJESTO_ID:'', NAZIV:''});


  
  const inputRefUlice = React.useRef();
  
  const [highlightedOption, setHighlightedOption] = React.useState(null);
  
  const [openMjesto, setOpenMjesto] = React.useState(false);
  const [loadingMjesto, setLoadingMjesto] = React.useState(false);
  const inputRefMjesto = React.useRef();
  
  const [highlightedOptionMjesto, setHighlightedOptionMjesto] = React.useState(null);
  
  
  
  React.useEffect(() => {
      const fetchData = async () => {
        if (ulica && ulica.length >= 3) {
          setLoading(true);
          await searchForUlica(ulica, 'ulice');
       
          setOpen(true);
          setLoading(false);
        } else {
          setOpen(false);
  
        }
      };
      
      fetchData();
    }, [ulica]);
  
  
    React.useEffect(() => {
      const fetchDataMjesto = async () => {
        if (mjesto && mjesto.length >= 3) {
          console.log("I'm gonna attempt searching!!!!!");
          console.log(mjesto);
          setLoadingMjesto(true);
          await searchForMjesto(mjesto);
       
          setOpenMjesto(true);
          setLoadingMjesto(false);
        } else {
          setOpenMjesto(false);
  
        }
      };
      
      fetchDataMjesto();
    }, [mjesto]);
  


      const handleKeyDownUlica = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent form submit or default behavior

      if (!selectedUlica && highlightedOption) {
        console.log(highlightedOption);
        setSelectedUlica(highlightedOption);

        // blur the input after selection
        if (inputRefUlice.current) {
          inputRefUlice.current.blur();
        }
        setOpen(false); // close dropdown

        
      }
      if(selectedUlica){
        kbr_ref.current.focus();
      }
    }
  };


  const handleKeyDownMjesto = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent form submit or default behavior

      console.log("aaaaaaaaaaaaaaaaaaaaaaaaa")

      console.log(selectedMjesto);
      console.log(highlightedOptionMjesto)
      if (!selectedMjesto && highlightedOptionMjesto) {

        console.log(highlightedOptionMjesto);
        setSelectedMjesto(highlightedOptionMjesto);

        console.log(inputRefMjesto)
        console.log(inputRefMjesto.current);
        console.log("******")

        // blur the input after selection
        if (inputRefMjesto.current) {
          inputRefMjesto.current.blur();
        }
        setOpenMjesto(false); // close dropdown

        
        
      }
      if(selectedMjesto){
        inputRefUlice.current.focus();

      }
    }
  };

async function searchForUlica(val, list){

    console.log("Searching for ulica");
    console.log("Mjesto");
    console.log(mjesto);
    console.log(selectedMjesto);

    if(val.length>2){
       
        APICall(
            '/getUlicaSuggestion',
            {
    
                platform: '0',
                version:'1.0',

                val: val,
                mjesto: selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:selectedMjesto.mjesto_id
    
            },
            {
                token
            }).then(
    
    
                (response) => {
                    console.log(response)
    
    
                    if (response.status==200) {
                        
                          
                            console.log("Obicne uliceeeeeeeeeeeeee")
                            console.log(response.data.strukture)
                            setListUlice(response.data.strukture)

                            console.log("Gotten the list of ulice");
                            console.log(ulica);
                            
                           
    
    
                    }
    
            
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
       
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });
    } else{
        setListUlice([])
        
        

    }
}

async function searchForMjesto(val){

    if(val.length>2){
       
        APICall(
            '/getMjestoSuggestion',
            {
    
                platform: '0',
                version:'1.0',

                val: val
    
            },
            {
                token
            }).then(
    
    
                (response) => {
                    console.log(response)
    
    
                    if (response.status==200) {
                        

                                    setListMjesta(response.data.strukture)

                                    if(response.data.strukture.length == 1){
                                        console.log("Samo jedno mjesto!!");
                                        console.log(response.data.strukture);


                                    }
    
    
                    }
    
            
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
       
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });
    } else{
        setListMjesta([])
    }
}


function cleanString(input) {
  let str = input ?? '';
  return str.replace(/([^a-zA-Z0-9])\1+/g, '$1');
}

  /******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************STATE VARIJABLE**************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


const toastError = {                                                        
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "light",
};

const toastSuccess = {                                                        
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
};

const toastInfo = {                                                        
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
};


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************USE EFFECT********************************************************************************* */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const [listOperatori, setListOperatori] = useState([]);
const [listPrikljucak, setListPrikljucak] = useState([]);

const [newPhone, setNewPhone] = useState(false);
const [newPhoneChecked, setNewPhoneChecked] = useState(false);

const [tip, setTip] = useState(null);

useEffect(() => {

        GetOperatori();

        GetPrikljucak();

}, []);

useEffect(()=>{
        document.title="Telefoni"
},[])


const GetPrikljucak = async() => {
    dispatch(actions.isLoading());
    await  APICall("/GetPrikljucak", {

    },{
      token
    }).then(response => {
            if(response.status !== 200) {

              if(response.status == 401){

                      console.log("Istekla sesija");

                      toast.error(response.data.message, toastError);
                      
                      dispatch(actions.logOut());
                      navigate('/');

              } else{

                      //toast.error(response.data.message, toastError);

              }


          } else {
              

                  let tmp = response.data.list;

                  console.log(tmp)
    

                  setListPrikljucak(tmp);
          }


          if (response==undefined) dispatch(actions.isNotLoading());
    })
    dispatch(actions.isNotLoading());
};


const GetOperatori = async() => {
    dispatch(actions.isLoading());
    await  APICall("/GetOperatoriList", {

    },{
      token
    }).then(response =>{
            if(response.status !== 200) {

              if(response.status == 401){

                      console.log("Istekla sesija");

                      toast.error(response.data.message, toastError);
                      
                      dispatch(actions.logOut());
                      navigate('/');

              } else{

                      //toast.error(response.data.message, toastError);

              }


          } else {
              

                  let tmp = response.data.list;
                  //tmp = tmp.sort((a,b) => a.pozivni - b.pozivni);

                  console.log("aaaaaaaaaaa list of pozivni seeeeeeeeeeet")

                  setListOperatori(tmp);
          }


          if (response==undefined) dispatch(actions.isNotLoading());
    })
    dispatch(actions.isNotLoading());
  };



  const handleChange = (event) => {

    console.log(event.target);

    let sel = '';

    if(event.target.value && event.target.value!=''){
            const selected = listOperatori.find((obj) => {
                console.log("Checking");
                console.log(obj);
                console.log(obj.id);
                console.log(event.target.value);
                
                if (obj.id === event.target.value)
                return obj;
            });
            console.log(selected);
            setOperater(selected);


    } else {

            sel = {id:'', naziv:''}
           
            setOperater(sel);
           

    }

 


};




  const handleChangePriklj = (event) => {

    console.log(event.target);

    console.log(listPrikljucak);

    let sel = '';

    if(event.target.value && event.target.value!=''){
            const selected = listPrikljucak.find((obj) => {
                console.log("Checking");
                console.log(obj);
                console.log(obj.naziv);
                console.log(event.target.value);
                
                if (obj && obj.naziv && obj.naziv.localeCompare(event.target.value)==0 )
                return obj;
            });
            console.log(selected);
            setPriklj(selected);


    } else {

            sel = {naziv:''}
           
            setPriklj(sel);
           

    }

 


};


  async function getTelefoni() {



        dispatch(actions.isLoading());

 
        APICall(
            '/getTelefoni',
            {

  
                mreza: mreza,
                telefon: telefon,
                ref:ref

            },
            {
                token
            }).then(

                (response) => {
                    console.log(response)
                    
                    dispatch(actions.isNotLoading());

                    if(response==undefined) dispatch(actions.isNotLoading());

                    if (response.status==200) {
                        if(response.data.rez){


                                    let tel = response.data.rez[0];

                                    console.log(tel);

                                    setVlasnik(tel.vlasnik);
                                    setKorisnik(tel.korisnik);


                            


                                    setTip1(tel.tip1);
                                    setTip2(tel.tip2);
                                    setTip2(tel.tip2);

                                    console.log(tel.tip1);
                                    console.log(tel.tip2);
                                    console.log(tel.tip3);

                                    let tmpTip1 = tel.tip1?tel.tip1:'';
                                    let tmpTip2 = tel.tip2?tel.tip2:'';
                                    let tmpTip3 = tel.tip3?tel.tip3:'';

                                    if(tmpTip1.localeCompare('Poslovni')==0 && (tmpTip3.localeCompare('Poslovni')==0 || tmpTip2.localeCompare('Poslovni')==0)){

                                      setTip(3);

                                    } else if(tmpTip1.localeCompare('Poslovni')==0 && (tmpTip3.toLowerCase().includes('brtni')==0 || tmpTip2.toLowerCase().includes('brtni')==0)){

                                      setTip(2);

                                    } else {


                                      setTip(1);
                                    }



                                    setNaziv1(tel.naziv1);
                                    setNaziv2(tel.naziv2);
                                    setNaziv3(tel.naziv3);
                                    setTitula(tel.titula);
                                    setSifra(tel.sifra);

                                                 

       
                                    
                                    setSelectedMjesto({MJESTO_ID:tel.mjesto_id, NAZIV:tel.mjesto});
                                    setMjesto(tel.mjesto);
                                    setSelectedUlica({ULICA_ID: tel.ulica_id, NAZIV:tel.ulica});
                                    setUlica(tel.ulica);
                                    //setMjesto(tel.mjesto);
                                    //setUlica(tel.ulica);
                                    setPTT(tel.ptt);
                                    setKbr(tel.kbr);

                                    setZnak(tel.znak);

                                  


                                    if(!tel.tajni){
                                        setTajniChecked(false);
                                        setTajni(tel.tajni);                                      
                                    } else if(tel.tajni && tel.tajni.toLowerCase().includes('ije')){

                                        setTajniChecked(false);
                                        setTajni(tel.tajni);
                                    } else {

                                        setTajniChecked(true);
                                        setTajni(tel.tajni);
                                    }


                                    //let checkedT = tel.tajni==1?true:false;
                                    //setTajniChecked(tel.tajni);
                                    ///setTajniChecked(checkedT);

                                    //let tajniRijec = tel.tajni==1?"Tajni":"Nije tajni";

                                    //setTajni(tajniRijec);

                                    setObrnuto(tel.obrnuto);

                                    
                                    setMB(tel.MB);
                                    setOIB(tel.OIB);

                                    setVPN(tel.vpn);
                                    setClip(tel.clip);
                                    setSMS(tel.sms);
                                    setPrivremen(tel.privremen);
                                    setSimpaVer(tel.simpaVer);
                                    
                                    //setObjava(tel.objava);
                                    //setTipObjava(tel.tipobjava);


                                    let selectedObj = listObjava.find((obj) => {

                                        
                                        
                                        if (obj.id == tel.objava)
                                        return obj;
                                    });

                                    console.log(selectedObj);
                    
                                    setObjava(selectedObj.id);
                                    setTipObjava(selectedObj.desc);
                                    setSelectedObjava(selectedObj);


                                    setKomentar(tel.komentar);

                                    setizvTip1(tel.izvTip1);
                                    setizvTip2(tel.izvTip2);
                                    setizvTip3(tel.izvTip3);

                                    setIzvMjesto(tel.izvMjesto);
                                    setIzvAdresa(tel.izvAdresa);
                                    setIzvPTT(tel.izvPTT);
                                    setTis(tel.tis);
                                    

                                    setDatum(tel.datum);


                                    setKomentDonat(tel.komentDonat);
                                    setWeb(tel.web);
                                    setStatus(tel.izvor_status);
                                    setLastActDonat(tel.lastAct);
                                    setDonatID(tel.donatID);
                                    setNKD(tel.nkd);
                                    setMarket(tel.market);

                                    console.log(operater);
                                    console.log(tel.tk_operator);
                                    console.log("Checking!!!!");

                                    let selected = listOperatori.find((obj) => {

                                        
                                        
                                        if (obj.id == tel.tk_operator)
                                        return obj;
                                    });

                                    console.log(selected);
                    
                                    setOperater(selected);


                                    //setOperater(tel.tk_operator);


                                    let selectPriklj = listPrikljucak.find((obj) => {

                                        
                                        
                                        if (obj && obj.naziv && obj.naziv.localeCompare(tel.priklj) === 0)
                                        return obj;
                                    });
                                    console.log(selectPriklj);
                    
                                    setPriklj(selectPriklj);

                                    //setPriklj(tel.priklj);

                        } else {

                                    console.log("Nema tvrtke?");

                                    toast.error("Nije pronađen nijedan telefon s traženim parametrima, molimo provjerite mrežu i/ili broj telefona", toastError);

            


                        }
                




                    
                    } else {

                            console.log("Tuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu");
                            console.log(response);

                            if(response.status == 401){

                                    toast.error(response.data.message,
                                        toastError);
                            
                                    setTimeout(() => {
                                        dispatch(actions.logOut());
                                        navigate('/');
                                    }, 5000);   


                            } else {

                                toast.error(response.data.message, toastError);

                                
                            }

                    }

            
                        
                
                },

                (error) => {

                    dispatch(actions.isNotLoading());

                
       


                
                            if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                                
                              
                            


                            } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                 

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);

                                    }
                                }
                            }
                        

                });

                
                
  }  


 async function newTelefon() {


console.log(mreza);
console.log(telefon);
console.log(operater);

if(mreza && mreza!='' && telefon && telefon!='' && naziv1 && naziv1!='' && operater && operater.id &&operater.id!='' 
  && objava!='' 
){

let oznaka = mreza + '' + telefon;
console.log(oznaka);

console.log(naziv1);
console.log(naziv2);




        dispatch(actions.isLoading());


     
 
        APICall(
            '/unesiNoviTel',
            {

  
                mreza: mreza,
                telefon: telefon,

                juzer:ref,
                ref:ref,

                naziv1_instalacije: naziv1?naziv1.toUpperCase():'',
                naziv2_instalacije: naziv2?naziv2.toUpperCase():'',
                naziv3_instalacije: naziv3?naziv3.toUpperCase():'',

                naziv1_instalacije_n: naziv1?naziv1.toUpperCase():'',
                naziv2_instalacije_n: naziv2?naziv2.toUpperCase():'',
                naziv3_instalacije_n: naziv3?naziv3.toUpperCase():'',

                tk_operator: operater?operater.id:'',
                tk_operator_n: operater?operater.id:'',


                adm_mj_id: selectedMjesto?(selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:(selectedMjesto.mjesto_id?selectedMjesto.mjesto_id:'0')):'0',
                adm_mjesto: selectedMjesto?(selectedMjesto.NAZIV?selectedMjesto.NAZIV:(selectedMjesto.naziv?selectedMjesto.naziv:'')):'',
                adm_ul_id: selectedUlica?(selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:(selectedUlica.ulica_id?selectedUlica.ulica_id:'0')):'0',
                adm_ulica: selectedUlica?(selectedUlica.NAZIV?selectedUlica.NAZIV:(selectedUlica.naziv?selectedUlica.naziv:'')):'',


                adm_mj_id: selectedMjesto?(selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:(selectedMjesto.mjesto_id?selectedMjesto.mjesto_id:'0')):'0',
                adm_ul_id: selectedUlica?(selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:(selectedUlica.ulica_id?selectedUlica.ulica_id:'0')):'0',


                oib: OIB?OIB:'',
                oib_n: OIB?OIB:'',
                izvor:'01',
                tkc:mreza,

                objava: objava?objava:'',
                objava_n: objava?objava:'',

                obrnuto:obrnuto?obrnuto:'',
                radni_komentar: komentar?komentar:'',

                obrnuto_n:obrnuto?obrnuto:'',
                radni_komentar_n: komentar?komentar:'',


                tip1:tip1?tip1:'',
                tip2:tip2?tip2:'',
                tip3:tip3?tip3:'',


                tip1_n:tip1?tip1:'',
                tip2_n:tip2?tip2:'',
                tip3_n:tip3?tip3:'',

                tajnost: tajni?tajni:'',
                tajnost_n: tajni?tajni:'',

                adm_broj_poste:ptt?ptt:'',
                adm_kucni_broj:kbr?kbr:'',
                adm_kbr_dodatak:znak?znak.toUpperCase():'',

                adm_kucni_broj_n:kbr?kbr:'',
                adm_kbr_dodatak_n:znak?znak.toUpperCase():'',           


            },
            {
                token
            }).then(

                (response) => {
                    console.log(response)
                    
                    dispatch(actions.isNotLoading());

                    if(response==undefined) dispatch(actions.isNotLoading());

                    if (response.status==200) {
                       



                                    setVlasnik('');
                                    setKorisnik('');

                                    setTip1('');
                                    setTip2('');
                                    setTip2('');



                                    setNaziv1('');
                                    setNaziv2('');
                                    setNaziv3('');
                                    setTitula('');
                                    setSifra('');
                                    setMjesto('');

                                    setSelectedMjesto({MJESTO_ID:'', NAZIV:''});
                                  
                                    setSelectedUlica({ULICA_ID: '', NAZIV:''});
                                   

                                    setUlica('');
                                    setPTT('');
                                    setKbr('');

                                    setZnak('');
                                    setTajniChecked(false);

                                    let tajniRijec = "Nije tajni";

                                    setTajni(tajniRijec);

                                    setObrnuto('');

                                    
                                    setMB('');
                                    setOIB('');

                                    setVPN('');
                                    setClip('');
                                    setSMS('');
                                    setPrivremen('');
                                    setSimpaVer('');
                                    setObjava('');
                                    setTipObjava('');
                                    setSelectedObjava({id:'', desc:''});


                                    setKomentar('');

                                    setizvTip1('');
                                    setizvTip2('');
                                    setizvTip3('');

                                    setIzvMjesto('');
                                    setIzvAdresa('');
                                    setIzvPTT('');
                                    setTis('');
                                    



                                    setDatum('');


                                    setKomentDonat('');
                                    setWeb('');
                                    setStatus('');
                                    setLastActDonat('');
                                    setDonatID('');
                                    setNKD('');
                                    setMarket('');

                    

                                    toast.success("Uspješno spremljena izmjena", toastSuccess);

            

                




                    
                    } else {

                            console.log("Tuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu");
                            console.log(response);

                            if(response.status == 401){

                                    toast.error(response.data.message,
                                        toastError);
                            
                                    setTimeout(() => {
                                        dispatch(actions.logOut());
                                        navigate('/');
                                    }, 5000);   


                            } else {

                                toast.error(response.data.message, toastError);

                                
                            }

                    }

            
                        
                
                },

                (error) => {

                    dispatch(actions.isNotLoading());

                
       


                
                            if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                                
                              
                            


                            } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                 

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);

                                    }
                                }
                            }
                        

                });

} else {
  
    toast.error("Niste unijeli sve nužne podatke molimo provjerite unešeno", toastError);

  }       
                
  }  


 async function updateTelefon() {


console.log(mreza);
console.log(telefon);
console.log(operater);

console.log(tajni);

console.log(tajniChecked)



if(mreza && mreza!='' && telefon && telefon!='' && naziv1 && naziv1!='' && operater && operater.id &&operater.id!='' 
  && objava!=''
){

let oznaka = mreza + '' + telefon;
console.log(oznaka);

console.log(naziv1);
console.log(naziv2);




        dispatch(actions.isLoading());


     
 
        APICall(
            '/updateTelefon',
            {

  
                mreza: mreza,
                telefon: telefon,
                ref:ref,

                juzer:ref,

                naziv1_instalacije: naziv1?naziv1.toUpperCase():'',
                naziv2_instalacije: naziv2?naziv2.toUpperCase():'',
                naziv3_instalacije: naziv3?naziv3.toUpperCase():'',

                naziv1_instalacije_n: naziv1?naziv1.toUpperCase():'',
                naziv2_instalacije_n: naziv2?naziv2.toUpperCase():'',
                naziv3_instalacije_n: naziv3?naziv3.toUpperCase():'',

                tk_operator: operater?operater.id:'',
                tk_operator_n: operater?operater.id:'',


                adm_mj_id: selectedMjesto?(selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:(selectedMjesto.mjesto_id?selectedMjesto.mjesto_id:'0')):'0',
                adm_mjesto: selectedMjesto?(selectedMjesto.NAZIV?selectedMjesto.NAZIV:(selectedMjesto.naziv?selectedMjesto.naziv:'')):'',
                adm_ul_id: selectedUlica?(selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:(selectedUlica.ulica_id?selectedUlica.ulica_id:'0')):'0',
                adm_ulica: selectedUlica?(selectedUlica.NAZIV?selectedUlica.NAZIV:(selectedUlica.naziv?selectedUlica.naziv:'')):'',

                adm_mj_id: selectedMjesto?(selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:(selectedMjesto.mjesto_id?selectedMjesto.mjesto_id:'0')):'0',
                adm_ul_id: selectedUlica?(selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:(selectedUlica.ulica_id?selectedUlica.ulica_id:'0')):'0',

                oib: OIB?OIB:'',
                oib_n: OIB?OIB:'',
                izvor:'01',
                tkc:mreza,

                objava: objava?objava:'',
                objava_n: objava?objava:'',

                obrnuto:obrnuto?obrnuto:'',
                radni_komentar: komentar?komentar:'',

                obrnuto_n:obrnuto?obrnuto:'',
                radni_komentar_n: komentar?komentar:'',


                tip1:tip1?tip1:'',
                tip2:tip2?tip2:'',
                tip3:tip3?tip3:'',


                tip1_n:tip1?tip1:'',
                tip2_n:tip2?tip2:'',
                tip3_n:tip3?tip3:'',

                tajnost: tajni?tajni:'',
                tajnost_n: tajni?tajni:'',

                adm_broj_poste:ptt?ptt:'',
                adm_broj_poste:ptt?ptt:'',
                adm_kucni_broj:kbr?kbr:'',
                adm_kbr_dodatak:znak?znak.toUpperCase():'',

                adm_kucni_broj_n:kbr?kbr:'',
                adm_kbr_dodatak_n:znak?znak.toUpperCase():'',            


            },
            {
                token
            }).then(

                (response) => {
                    console.log(response)
                    
                    dispatch(actions.isNotLoading());

                    if(response==undefined) dispatch(actions.isNotLoading());

                    if (response.status==200) {
              



                                    setVlasnik('');
                                    setKorisnik('');

                                    setTip1('');
                                    setTip2('');
                                    setTip2('');



                                    setNaziv1('');
                                    setNaziv2('');
                                    setNaziv3('');
                                    setTitula('');
                                    setSifra('');
                                    setMjesto('');

                                    
                                    setSelectedMjesto({MJESTO_ID:'', NAZIV:''});
                                  
                                    setSelectedUlica({ULICA_ID: '', NAZIV:''});


                                    setUlica('');
                                    setPTT('');
                                    setKbr('');

                                    setZnak('');
                                    setTajniChecked(false);

                                    let tajniRijec = "Nije tajni";

                                    setTajni(tajniRijec);

                                    setObrnuto('');

                                    
                                    setMB('');
                                    setOIB('');

                                    setVPN('');
                                    setClip('');
                                    setSMS('');
                                    setPrivremen('');
                                    setSimpaVer('');
                                    setObjava('');
                                    setTipObjava('');
                                    setSelectedObjava({id:'', desc:''});


                                    setKomentar('');

                                    setizvTip1('');
                                    setizvTip2('');
                                    setizvTip3('');

                                    setIzvMjesto('');
                                    setIzvAdresa('');
                                    setIzvPTT('');
                                    setTis('');
                                    



                                    setDatum('');


                                    setKomentDonat('');
                                    setWeb('');
                                    setStatus('');
                                    setLastActDonat('');
                                    setDonatID('');
                                    setNKD('');
                                    setMarket('');

                    

                                    toast.success("Uspješno spremljene izmjene",
                                        toastSuccess);



                    
                    } else {

                            console.log("Tuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu");
                            console.log(response);

                            if(response.status == 401){

                                    toast.error(response.data.message,
                                        toastError);
                            
                                    setTimeout(() => {
                                        dispatch(actions.logOut());
                                        navigate('/');
                                    }, 5000);   


                            } else {

                                toast.error(response.data.message, toastError);

                                
                            }

                    }

            
                        
                
                },

                (error) => {

                    dispatch(actions.isNotLoading());

                
       


                
                            if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                                
                              
                            


                            } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                 

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);

                                    }
                                }
                            }
                        

                });

} else {
  
    toast.error("Niste unijeli sve nužne podatke molimo provjerite unešeno", toastError);
  }       
                
  }  

 async function brisiTelefon() {


console.log(mreza);
console.log(telefon);


if(mreza && mreza!='' && telefon && telefon!=''){

let oznaka = mreza + '' + telefon;
console.log(oznaka);



        dispatch(actions.isLoading());


     
 
        APICall(
            '/brisiTelefon',
            {

  
                mreza: mreza,
                telefon: telefon,

                juzer:ref,
                ref:ref




            },
            {
                token
            }).then(

                (response) => {
                    console.log(response)
                    
                    dispatch(actions.isNotLoading());

                    if(response==undefined) dispatch(actions.isNotLoading());

                    if (response.status==200) {
              



                                    setVlasnik('');
                                    setKorisnik('');

                                    setTip1('');
                                    setTip2('');
                                    setTip2('');



                                    setNaziv1('');
                                    setNaziv2('');
                                    setNaziv3('');
                                    setTitula('');
                                    setSifra('');
                                    setMjesto('');


                                    
                                    setSelectedMjesto({MJESTO_ID:'', NAZIV:''});
                                  
                                    setSelectedUlica({ULICA_ID: '', NAZIV:''});


                                    setUlica('');
                                    setPTT('');
                                    setKbr('');

                                    setZnak('');

                                    setTajniChecked(false);

                                    let tajniRijec = "Nije tajni";

                                    setTajni(tajniRijec);



                                    setObrnuto('');

                                    
                                    setMB('');
                                    setOIB('');

                                    setVPN('');
                                    setClip('');
                                    setSMS('');
                                    setPrivremen('');
                                    setSimpaVer('');
                                    setObjava('');
                                    setTipObjava('');
                                    setSelectedObjava({id:'', desc:''});



                                    setKomentar('');

                                    setizvTip1('');
                                    setizvTip2('');
                                    setizvTip3('');

                                    setIzvMjesto('');
                                    setIzvAdresa('');
                                    setIzvPTT('');
                                    setTis('');
                                    



                                    setDatum('');


                                    setKomentDonat('');
                                    setWeb('');
                                    setStatus('');
                                    setLastActDonat('');
                                    setDonatID('');
                                    setNKD('');
                                    setMarket('');

                    


                                    toast.success("Uspješno obrisan telefon", toastSuccess);


                    
                    } else {

                            console.log("Tuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu");
                            console.log(response);

                            if(response.status == 401){

                                    toast.error(response.data.message,
                                        toastError);
                            
                                    setTimeout(() => {
                                        dispatch(actions.logOut());
                                        navigate('/');
                                    }, 5000);   


                            } else {

                                toast.error(response.data.message, toastError);

                                
                            }

                    }

            
                        
                
                },

                (error) => {

                    dispatch(actions.isNotLoading());

                
       


                
                            if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                                
                              
                            


                            } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                 

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);

                                    }
                                }
                            }
                        

                });

} else {
  
    toast.error("Niste unijeli sve nužne podatke molimo provjerite unešeno");
  }       
                
  }  






const handleTipChange = (event) => {
    
    setTip(event.target.id);
    
    console.log(event);
    console.log(event.target.id);

    console.log("Tražena vrijednost tipa je: " + event.target.id);

    if(event.target.id==1){

      setTip1("Privatni");
      setTip3("Privatni");
    } else if (event.target.id==2){

      setTip1("Poslovni");
      setTip3("Obrtnik");
    }else {
      setTip1("Poslovni");
      setTip3("Poslovni");
    }


};




const handleObjavaChange = (event) => {
    
   
    console.log(event.target);

    let sel = '';

    if(event.target.value && event.target.value!=''){

            const selected = listObjava.find((obj) => {
                console.log("Checking");
                console.log(obj);
                
                if (obj.id == event.target.value)
                return obj;
            });
            console.log("selected");
            console.log(selected);
            setObjava(selected.id);
            setTipObjava(selected.desc);
            setSelectedObjava(selected);


    } else {

            sel = {id:'', desc:''}
           
            setObjava('');
            setTipObjava('');
            setSelectedObjava({id:'', desc:''});
           

    }
 
  
};

const handleTajniCheckboxChange = (event) => {
    setTajniChecked(event.target.checked);
    let tmpTajni = event.target.checked==1?"Tajni":"Nije tajni";

    setTajni(tmpTajni);
};


  return (
    <ThemeProvider theme={theme}>
      <div className='main-container'>

        {/*FORMA*/}
        <div className='form-container'>

          {/*Prvi box*/}
          <div className='card-container'>

            {/*Prvi red*/}
            <div className='row-container'>

                                                <Grid container xs={12} sx={{border:"1px solid black", backgroundColor:'#AFE1AF'}} spacing={0.75}>
                                                    <Grid xs={12}>
                                                       <Typography  sx={{fontSize:'11px'}}>
                                                            Izbor telefona
                                                        </Typography>
                                                    </Grid>         
                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                size="small"
                                                                                fullWidth
                                                                                id=""
                                                                                label="Mreža"
                                                                                variant="outlined"

                                                                                value={mreza}
                                                                                
                                                                                onChange={(event) => {
                                                                                    setMreza(event.target.value)

                                                                                    
                                                                                }}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){
                                                                                        console.log('Enter Pressed')
                                                                                        console.log(mreza);
                                                                                      

                                                                                        tel_ref.current.focus();
                                                                                    }
                                                                                }}

                                                                                inputRef={mreza_ref}
                                     

                                                                                  onFocus={event => {
                                                                                                          
                                                                                      event.target.select()
                                                                                          
                                                                                  }}    


                                                                            />

                                                    </Grid>
                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                            size="small"
                                                            fullWidth
                                                            id=""
                                                            label="Telefon:"
                                                            variant="outlined"

                                                            inputRef={tel_ref}

                                                            value={telefon}
                                                            
                                                            onChange={(event) => {
                                                                setTelefon(event.target.value);
                                                            }}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter'){
                                                                    console.log('Enter Pressed')
                                                                    console.log(telefon);
                                                                    getTelefoni();
                                                                }
                                                            }}
                                                        />


                                                    </Grid>
                                                </Grid>



              </div> 
              <div className='row-container'>
                                                <Grid container xs={12}>
                                                    <Grid xs={3} sx={{paddingRight:5}}>
                                                        <FormControlLabel control={<Checkbox size="small" checked={newPhoneChecked} onClick={()=>{
                                                                                            if(!newPhone) {
                                                                                            
                                                                                              
                                                                                                  setVlasnik('');
                                                                                                  setKorisnik('');

                                                                                                  setTip1('');
                                                                                                  setTip2('');
                                                                                                  setTip2('');



                                                                                                  setNaziv1('');
                                                                                                  setNaziv2('');
                                                                                                  setNaziv3('');
                                                                                                  setTitula('');
                                                                                                  setSifra('');
                                                                                                  setMjesto('');

                                                                                                  
                                    setSelectedMjesto({MJESTO_ID:'', NAZIV:''});
                                  
                                    setSelectedUlica({ULICA_ID: '', NAZIV:''});
                                                                                                  setUlica('');
                                                                                                  setPTT('');
                                                                                                  setKbr('');

                                                                                                  setZnak('');
                                                                                                  setTajniChecked('');

                                                                                                  let tajniRijec = "Nije tajni";

                                                                                                  setTajni('');

                                                                                                  setObrnuto('');

                                                                                                  
                                                                                                  setMB('');
                                                                                                  setOIB('');

                                                                                                  setVPN('');
                                                                                                  setClip('');
                                                                                                  setSMS('');
                                                                                                  setPrivremen('');
                                                                                                  setSimpaVer('');
                                    setObjava('');
                                    setTipObjava('');
                                    setSelectedObjava({id:'', desc:''});

                                                                                                  setKomentar('');

                                                                                                  setizvTip1('');
                                                                                                  setizvTip2('');
                                                                                                  setizvTip3('');

                                                                                                  setIzvMjesto('');
                                                                                                  setIzvAdresa('');
                                                                                                  setIzvPTT('');
                                                                                                  setTis('');
                                                                                                  



                                                                                                  setDatum('');


                                                                                                  setKomentDonat('');
                                                                                                  setWeb('');
                                                                                                  setStatus('');
                                                                                                  setLastActDonat('');
                                                                                                  setDonatID('');
                                                                                                  setNKD('');
                                                                                                  setMarket('');                                                                                             
                                                                                            
                                                                                            }
                                                                                            setNewPhone(!newPhone);
                                                                                            setNewPhoneChecked(!newPhoneChecked);
                                                                                            


                                                                        }}/>} label={<Typography sx={{fontSize:'15px'}}>Unos novog telefona</Typography>}/> 
                                                    
                                                    </Grid>         
                                                    <Grid xs={4.5} sx={{paddingRight:5}}>

                                                        <Button sx={{height:"30px", fontSize:"10px", marginBottom:'5px', marginTop:'5px'}} 
                                                                variant="contained" 
                                                                fullWidth
                                                                color="success" 
                                                                onClick={() => {
                                                                    
                                                                    if(newPhone){

                                                                        newTelefon();

                                                                    } else {

                                                                        updateTelefon();

                                                                    }
                                                                  
                                                                }}>
                                                            Spremi telefon
                                                        </Button>
                                                    </Grid>
                                                    <Grid xs={4.5}>

                                                        <Button sx={{height:"30px", fontSize:"10px", marginBottom:'5px', marginTop:'5px'}} 
                                                                variant="contained" 
                                                                fullWidth
                                                                color="error" 
                                                                onClick={() => {
                                                                    
                                                                   brisiTelefon();
                                                                }}>
                                                            Obriši Telefon
                                                        </Button>
                                                    </Grid>

                                                </Grid>
            </div>
            <div className='row-container'>
              <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',  gap : formRowGap }}>
                <div style={{ width: '100%', marginRight: '0px' }}>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="vlasnik"
                    label="Vlasnik"
                    variant="outlined"
                    value={vlasnik}
                    onChange={(event) => {
                      setVlasnik(event.target.value);
                    }}
                  />
                </div>
                <div style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <Checkbox sx={{padding:0}}
                    checked={vlasnikChecked}
                    onChange={handleVlasnikCheckboxChange}
                  />
                </div>
              </div>
            </div>

            {/*Treci red*/}
            <div className='row-container'>
              <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',  gap : formRowGap }}>
                <div style={{ width: '100%', marginRight: '0px' }}>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="korisnik"
                    label="Korisnik"
                    variant="outlined"
                    value={korisnik}
                    onChange={(event) => {
                      setKorisnik(event.target.value);
                    }}
                  />
                </div>
                <div style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <Checkbox sx={{padding:0}}
                    checked={korisnikChecked}
                    onChange={handleKorisnikCheckboxChange}
                  />
                </div>
              </div>
            </div>

          </div>

          {/*Drugi box*/}
          <div className='card-container'>
            {/*Prvi red*/}


            <div className='row-container'>
              <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>



                  <FormControl 
                                                  fullWidth
                                                  //variant="standard" 
                                                  sx={{ m: 1, width:'100%', margin:0}}
                                                  //size="small"
                                                  variant="outlined"
                                                  >
                                              <InputLabel sx={{fontSize: 12,
                                                    ontSize: '0.75rem', // smaller label font
                                                    top: '-6px', // shift label slightly up
                                              }}
                                                                       
                                              >Operator</InputLabel>
                                              <Select 
                                                  sx={{height:32, backgroundColor: 'lightyellow'}}
                                                  
                                                  
                                                  value={operater?.id || ""} onChange={handleChange}>
                                              {listOperatori.map((obj) => (
                                                  <MenuItem key={obj.id} value={obj.id}>
                                                  {obj.naziv}
                                                  </MenuItem>
                                              ))}
                                              <MenuItem value={''} name={''} >  </MenuItem>
                                              </Select>
                  </FormControl>


              </div>
            </div>

            {/*Drugi red*/}
            <div className='row-container'>
              <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                            <Typography  sx={{fontSize:'12px', width:'20%'}}>
                                Tip1/Tip3: 
                            </Typography>

                                <FormControl  sx={{width:'80%'}}>
                                    <RadioGroup 
                                  
                                    row
                                    name="Tip"
                                    onChange={handleTipChange}
                                    >
                                          <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '12px' } }} control={<Radio id='1' size="small"  />} checked={tip==1?true:false} label="Privatni / Privatni" />  
                                          <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '12px' } }} control={<Radio id='2' size="small" />} checked={tip==2?true:false} label="Poslovni / Obrtnik" />
                                          <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '12px' } }} control={<Radio id='3' size="small" />} checked={tip==3?true:false} label="Poslovni / Poslovni" />
                                    </RadioGroup>
                                </FormControl> 

              </div>
            </div>





            {/*Treci red*/}
            <div className='row-container'>
                <div style={{ width: '50%' }}>
                    <TextField
                      InputProps={{sx:{height:30, backgroundColor: 'lightyellow'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="prezime-naziv"
                    label="Prezime/Naziv"
                    variant="outlined"
                    value={naziv1}
                    onChange={(event) => {
                      setNaziv1(event.target.value);
                    }}
                  />
                </div>
                <div style={{ display: 'flex', width: '50%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{ width: '100%' }}>
                                    <TextField
                        InputProps={{sx:{height:30}}}
                        InputLabelProps={{
                              sx: {
                                  
                                  fontSize: "10px", shrink: true,
                                  
                                  "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                              }
                            }}
                            size="small"


                      fullWidth
                      id="ime"
                      label="Ime"
                      variant="outlined"
                      value={naziv2}
                      onChange={(event) => {
                        setNaziv2(event.target.value);
                      }}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{ width: '100%' }}>
                                    <TextField
                        InputProps={{sx:{height:30}}}
                        InputLabelProps={{
                              sx: {
                                  
                                  fontSize: "10px", shrink: true,
                                  
                                  "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                              }
                            }}
                            size="small"


                      fullWidth
                      id="naziv-ostatak"
                      label="Naziv-ostatak"
                      variant="outlined"
                      value={naziv3}
                      onChange={(event) => {
                        setNaziv3(event.target.value);
                      }}
                    />
                  </div>
              </div>
            </div>


            {/*Peti red*/}
            <div className='row-container'>
            </div>

            {/*Sesti red*/}
            <div className='row-container'>
                <div className='classForSpecificRowSestiDivPrvi '>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="titula"
                    label="Titula"
                    variant="outlined"
                    value={titula}
                    onChange={(event) => {
                      setTitula(event.target.value);
                    }}
                  />
                </div>
                <div className='classForSpecificRowSestiDivDrugi'>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="sifra"
                    label="Šifra"
                    variant="outlined"
                    value={sifra}
                    onChange={(event) => {
                      setSifra(event.target.value);
                    }}
                  />
                </div>
            </div>

            {/*Sedmi red*/}
            <div className='row-container'>
                <div className='classForSpecificRowSedmiDivPrvi'>


                                            <Grid sx={{}} container spacing={0.75} columns={{xs:12}}>
                                                    <Grid xs={4}>
                                                        <Autocomplete

                                                                    //freeSolo
                                                                    //open={open}
                                                                    
                                                                
                                                                    options={listMjesta}
                                                                    getOptionLabel={(option) => option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} // 👈 how to display text
                                                                    value={selectedMjesto}
                                                                    inputValue={mjesto}
                                                                    onHighlightChange={(event, option) => {
                                                                        setHighlightedOptionMjesto(option);
                                                                    }}
                                                                    onOpen={() => {
                                                                        setOpenMjesto(true); // Open only when clicked/focused
                                                                    }}
                                                                    onClose={() => {
                                                                        setOpenMjesto(false);
                                                                    }}
                                                                    onChange={(event, newValue) => {
                                                                        if (newValue) {
                                                                                console.log('Selected:', newValue);
                                                                                
                                                                                //setLoading(false);
                                                                                //setOpen(false);
                                                                                console.log(newValue)
                                                                                setSelectedMjesto(newValue)
                                                                                setMjesto(newValue.NAZIV?newValue.NAZIV:(newValue.naziv?newValue.naziv:''))

                                                                                //setTkcFirma(newValue.ID_TKC?newValue.ID_TKC:(newValue.id_tkc?newValue.id_tkc:''))

                                                                                setSelectedUlica({'ULICA_ID': 0, 'NAZIV':''});
                                                                                setUlica('');
                                                                                setKbr('');
                                                                                setZnak('');
                                                                            

                                                                                setListMjesta([])
                                                                                // Remove focus (blur)

                                                                                if (inputRefMjesto.current) {
                                                                                    inputRefMjesto.current.blur();
                                                                                }
                                                                                setOpenMjesto(false);
                                                                        }

                                                                        
                                                                    }}
                                                                    loading={loadingMjesto}
                                                                
                                                                    onInputChange={(event, newInputValue, reason) => {
                                                                        console.log("New input value is here!!!!")
                                                                        console.log(newInputValue);
                                                                       
                                                                        setMjesto(newInputValue);


                                                                      
                                                                        // Don't open while typing manually
                                                                        //if (reason === 'reset') {
                                                                        //    setOpenMjesto(false);
                                                                       // }
                                                                    }}

                                                                    renderInput={(params) => (
                                                                        <TextField

                                                                        {...params}

                                                                        label="Mjesto"
                                                                        size="small" // smaller baseline size
                                                                        InputProps={{
                                                                        ...params.InputProps,
                                                                        sx: {
                                                                            height: '30px',
                                                                            minHeight: '30px',
                                                                            '& input': {
                                                                            padding: '0 8px',
                                                                            height: '30px',
                                                                            boxSizing: 'border-box'
                                                                            },
                                                                        },
                                                                        }}
                                                                        InputLabelProps={{
                                                                        sx: {
                                                                            fontSize: '0.75rem', // smaller label font
                                                                            top: '-6px', // shift label slightly up
                                                                        }
                                                                        }}
                                                                        inputRef={inputRefMjesto}
                                                                        onKeyDown={handleKeyDownMjesto}
                                                                        onClick={() => setOpenMjesto(true)} // Open on click
                                                                        onFocus={() => setOpenMjesto(true)} // Open on focus
                                                                        />
                                                                    )}
                                                                    disableCloseOnSelect={false}

                                                                    autoHighlight

                                                                    onFocus={event => {
                                                                    
                                                                        event.target.select()
                                                    
                                                                    }}                                                                                                                                         
                                                                    />



                                                    
                                                    </Grid>
                                                    <Grid xs={8}>
                                              

                                                            <Autocomplete

                                                                //freeSolo
                                                                //open={open}
                                                                options={listUlice}
                                                                getOptionLabel={(option) => option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} // 👈 how to display text
                                                                value={selectedUlica}
                                                                inputValue={ulica}
                                                                onHighlightChange={(event, option) => {
                                                                    setHighlightedOption(option);
                                                                  }}
                                                                  onOpen={() => {
                                                                    setOpen(true); // Open only when clicked/focused
                                                                  }}
                                                                  onClose={() => {
                                                                    setOpen(false);
                                                                  }}
                                                                onChange={(event, newValue) => {
                                                                    if (newValue) {
                                                                      console.log('Selected:', newValue);
                                                                      
                                                                      //setLoading(false);
                                                                      //setOpen(false);
                                                                      console.log(newValue)
                                                                      setSelectedUlica(newValue)
                                                                      setUlica(newValue.NAZIV?newValue.NAZIV:(newValue.naziv?newValue.naziv:''))
                                                                      setListUlice([])
                                                                      // Remove focus (blur)

                                                                      if (inputRefUlice.current) {
                                                                        inputRefUlice.current.blur();
                                                                      }
                                                                      setOpen(false);
                                                                    }

                                                                    
                                                                  }}
                                                                loading={loading}
                                                           
                                                                onInputChange={(event, newInputValue, reason) => {
                                                                    console.log("New input value is here!!!!")
                                                                    console.log(newInputValue);
                                                                    setUlica(newInputValue);
                                                                    // Don't open while typing manually
                                                                    if (reason === 'reset') {
                                                                        setOpen(false);
                                                                    }
                                                                }}
                                                   
                                                                renderInput={(params) => (
                                                                    <TextField

                                                                    {...params}

                                                                    label="Ulica"
                                                                    size="small" // smaller baseline size
                                                                    InputProps={{
                                                                      ...params.InputProps,
                                                                      sx: {
                                                                        height: '30px',
                                                                        minHeight: '30px',
                                                                        '& input': {
                                                                          padding: '0 8px',
                                                                          height: '30px',
                                                                          boxSizing: 'border-box'
                                                                        },
                                                                      },
                                                                    }}
                                                                    InputLabelProps={{
                                                                      sx: {
                                                                        fontSize: '0.75rem', // smaller label font
                                                                        top: '-6px', // shift label slightly up
                                                                      }
                                                                    }}
                                                                    inputRef={inputRefUlice}
                                                                    onKeyDown={handleKeyDownUlica}
                                                                    onClick={() => setOpen(true)} // Open on click
                                                                    onFocus={() => setOpen(true)} // Open on focus
                                                                    />
                                                                )}
                                                                disableCloseOnSelect={false}
                                                             
                                                                autoHighlight

                                                                onFocus={event => {
                                                                
                                                                    event.target.select()
                                                
                                                                }}                                                               

                                                                                                                         
                                                                />
                                                           
                                                       
                                                    </Grid>

                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                size="small"
                                                                                fullWidth
                                                                                id=""
                                                                                label="Kbr"
                                                                                variant="outlined"

                                                                                value={kbr}
                                                                                
                                                                                onChange={(event) => {
                                                                                    setKbr(event.target.value);
                                                                                    
                                                                                }}
                                                                                inputRef={kbr_ref}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){

                                                                                        kbrZnak_ref.current.focus();
                                                                                    }
                                                                                }}

                                                                                onFocus={event => {
                                                                                  
                                                                                    event.target.select()
                                                                 
                                                                                }}

                                                        />
                                                        


                                                    </Grid>
                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                size="small"
                                                                                fullWidth
                                                                                id=""
                                                                                label="Dodatak"
                                                                                variant="outlined"

                                                                                value={znak}
                                                                                
                                                                                onChange={(event) => {
                                                                                    setZnak(event.target.value);
                                                                                    
                                                                                }}

                                                                                inputRef={kbrZnak_ref}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){

                                                                                        //komentar_ref.current.focus();
                                                                                    }
                                                                                }}

                                                                                onFocus={event => {
                                                                                  
                                                                                    event.target.select()
                                                                 
                                                                                }}

                                                        />


                                                    </Grid>

                                                     <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                size="small"
                                                                                fullWidth
                                                                                id=""
                                                                                label="PTT"
                                                                                variant="outlined"

                                                                                value={ptt}
                                                                                
                                                                                onChange={(event) => {
                                                                                    setPTT(event.target.value);
                                                                                    
                                                                                }}

                                                                                inputRef={ptt_ref}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){

                                                                                        //tajno_ref.current.focus();
                                                                                    }
                                                                                }}

                                                                                onFocus={event => {
                                                                                  
                                                                                    event.target.select()
                                                                 
                                                                                }}

                                                        />


                                                    </Grid>                                                   
                                      </Grid>






            </div>


                <div className='classForSpecificRowDevetiDivTreci'>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="tajni"
                    label="Tajni"
                    variant="outlined"
                    value={tajni}
                    onChange={(event) => {
                      setTajni(event.target.value);
                    }}
                  />
                    <div className='classForSpecificRowDevetiDivTreci'>

                   <Checkbox sx={{padding:0}}
                    checked={tajniChecked}
                    onChange={handleTajniCheckboxChange}

                  />
                   </div>
                </div>
                <div className='classForSpecificRowDevetiDivCetvrti'>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="obrnuto"
                    label="Obrnuto"
                    variant="outlined"
                    value={obrnuto}
                    onChange={(event) => {
                      setObrnuto(event.target.value);
                    }}
                  />
                </div>


            </div>

            {/*Deseti red*/}
            <div className='row-container'>
              <div className='classForSpecificRowDesetiDivPrvi'>

              {/*<FormControl variant="standard" sx={{ m: 1, width:'100%',margin:0 }}>
                
                  <InputLabel id="prikljucak">Priključak</InputLabel>
                  <Select
                                                                sx={{margin:0}}
                    labelId="prikljucak"
                    id="prikljucak-select"
                    value={selectedPrikljucakOption}
                    label="Priključak"
                    onChange={handleSelectPrikljucakChange}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {prikljucakOptions.map((option, index) => (
                      <MenuItem key={index} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>*/}

                  <FormControl 
                                                  fullWidth
                                                  //variant="standard" 
                                                  sx={{ m: 1, width:'100%', margin:0}}
                                                  //size="small"
                                                  variant="outlined"
                                                  >
                                              <InputLabel sx={{fontSize: 12, margin:0,
                                                                                                    ontSize: '0.75rem', // smaller label font
                                                    top: '-6px', // shift label slightly up
                                              }}>Priključak</InputLabel>
                                              <Select 
                                                  sx={{height:32}}
                                                  
                                                  value={priklj?.naziv || ""} onChange={handleChangePriklj}>
                                              {listPrikljucak.map((obj) => (
                                                  <MenuItem key={obj.naziv} value={obj.naziv}>
                                                  {obj.naziv}
                                                  </MenuItem>
                                              ))}
                                              <MenuItem value={''} name={''} >  </MenuItem>
                                              </Select>
                  </FormControl>                
              </div>

              <div className='classForSpecificRowDesetiDivDrugi'>
                                <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                  fullWidth
                  id="mb"
                  label="MB"
                  variant="outlined"
                  value={MB}
                  onChange={(event) => {
                    setMB(event.target.value);
                  }}
                />
              </div>
              <div className='classForSpecificRowDesetiDivTreci'>
                                <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                  fullWidth
                  id="oib"
                  label="OIB"
                  variant="outlined"
                  value={OIB}
                  onChange={(event) => {
                    setOIB(event.target.value);
                  }}
                />
              </div>

            </div>

            {/*Jedanaesti red*/}
            <div className='row-container'>

                <div className='classForSpecificRowJedanaestDivPrvi'>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="vpn"
                    label="VPN"
                    variant="outlined"
                    value={VPN}
                    onChange={(event) => {
                      setVPN(event.target.value);
                    }}
                  />
                </div>
                <div className='classForSpecificRowJedanaestDivDrugi'>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="clip"
                    label="Clip"
                    variant="outlined"
                    value={clip}
                    onChange={(event) => {
                      setClip(event.target.value);
                    }}
                  />
                </div>
                <div className='classForSpecificRowJedanaestDivDrugi'>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="sms"
                    label="SMS"
                    variant="outlined"
                    value={sms}
                    onChange={(event) => {
                      setSMS(event.target.value);
                    }}
                  />
                </div>
                <div className='classForSpecificRowJedanaestDivDrugi'>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="privremen"
                    label="Privremen"
                    variant="outlined"
                    value={privremen}
                    onChange={(event) => {
                      setPrivremen(event.target.value);
                    }}
                  />
                </div>
                <div className='classForSpecificRowJedanaestDivPeti'>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="simpaVerif"
                    label="Simpa Verif"
                    variant="outlined"
                    value={simpaVer}
                    onChange={(event) => {
                      setSimpaVer(event.target.value);
                    }}
                  />
                </div>
            </div>

            {/*Dvanaesti red*/}
            <div className='row-container'>
                <div style={{ width: '30%' }}>

                  <FormControl 
                                                  fullWidth
                                                  //variant="standard" 
                                                  sx={{ m: 1, width:'100%', backgroundColor: 'lightyellow', margin:0}}
                                                  //size="small"
                                                  variant="outlined"
                                                  >
                                              <InputLabel sx={{fontSize: 12,
                                                    ontSize: '0.75rem', // smaller label font
                                                    top: '-6px', // shift label slightly up
                                              }}>Objava</InputLabel>
                                              <Select 
                                                  sx={{height:32}}
                                                  
                                                  value={selectedObjava?.id || ""} onChange={handleObjavaChange}>
                                              {listObjava.map((obj) => (
                                                  <MenuItem key={obj.id} value={obj.id}>
                                                  {obj.id}
                                                  </MenuItem>
                                              ))}
                                              <MenuItem value={''} name={''} >  </MenuItem>
                                              </Select>
                  </FormControl>


                </div>
                <div style={{ width: '70%' }}>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="objava2"
                    label=""
                    variant="outlined"
                    value={tipObjava}
                    disabled

                  />
              </div>
            </div>

            {/*Trinaesti red*/}
            <div className='row-container'>
              <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: '100%' }}>
                                  <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="komentar"
                    label="Komentar"
                    variant="outlined"
                    value={komentar}
                    onChange={(event) => {
                      setKomentar(event.target.value);
                    }}
                  />
                </div>
              </div>
            </div>


          </div>

          {/*Treci box*/}
          <div className='card-container'>
            {/*Prvi red*/}
            <div className='row-container'>
              <div className='classForSpecificRowDrugiDivPrviBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="tip1"
                    label="Tip1,2,3"
                    variant="outlined"
                    value={izvTip1}
                    disabled
                  />
                </div>
                <div className='classForSpecificRowDrugiDivDrugiBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="tip2"
                    label=""
                    variant="outlined"
                    value={izvTip2}
                    disabled
                  />
                </div>
                <div className='classForSpecificRowDrugiDivTreciBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="tip3"
                    label=""
                    variant="outlined"
                    value={izvTip3}
                    disabled
                    onChange={(event) => {
                      
                    }}
                  />
                </div>
            </div>

            {/*Drugi red*/}
            <div className='row-container'>
                <div className='classForSpecificRowDrugiDivPrviBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="izvornoMjesto"
                    label="Izvorno mjesto"
                    variant="outlined"
                    value={izvMjesto}
                    disabled
                    onChange={(event) => {
                      
                    }}
                  />
                </div>
                <div className='classForSpecificRowDrugiDivDrugiBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="ptt"
                    label="PTT"
                    variant="outlined"
                    value={izvptt}
                    disabled
                    onChange={(event) => {
                      
                    }}
                  />
                </div>
                <div className='classForSpecificRowDrugiDivTreciBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="promjenaOd"
                    label="Promjena od"
                    variant="outlined"
                    value={datum}
                    disabled
                    
                  />
                </div>
            </div>

            {/*Treci red*/}
            <div className='row-container'>
              <div style={{ display: 'flex', width: "100%", flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="izvornaAdresa"
                    label="Izvorna adresa"
                    variant="outlined"
                    value={izvAdresa}
                    disabled
                    onChange={(event) => {
                      
                    }}
                  />
                </div>
              </div>
            </div>

            {/*Cetvrti red*/}
            <div className='row-container'>
              <div style={{ display: 'flex', width: "100%", flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    fullWidth
                    id="tisArhiva"
                    label="TIS-arhiva (T-mob)"
                    variant="outlined"
                    value={tis}
                    disabled
                    onChange={(event) => {
                     
                    }}
                  />
                </div>
              </div>
            </div>

            {/*Peti red*/}
            <div className='row-container'>
              <div style={{ display: 'flex', width: "100%", flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    fullWidth
                    id="napomDonat"
                    label="Napom Donat"
                    variant="outlined"
                    value={komentDonat}
                    disabled
                    onChange={(event) => {
                   
                    }}
                  />
                </div>
              </div>
            </div>

            {/*Sesti red*/}
            <div className='row-container'>

                <div className='classForSpecificRowSestiDivPrviBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="www"
                    label="WWW"
                    variant="outlined"
                    value={web}
                    disabled
                    onChange={(event) => {
                      
                    }}
                  />
                </div>
                <div className='classForSpecificRowSestiDivDrugiBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="status"
                    label="Status"
                    variant="outlined"
                    value={status}
                    disabled
                    onChange={(event) => {
                      setStatus(event.target.value);
                    }}
                  />
                </div>

            </div>

            {/*Sedmi red*/}
            <div className='row-container'>
                <div className='classForSpecificRowDevetiDivPrviBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="zadnjaAkcijaDonat"
                    label="Zadnja akcija Donat"
                    variant="outlined"
                    value={lastActDonat}
                    disabled
                    onChange={(event) => {
                      
                    }}
                  />
                </div>
                <div className='classForSpecificRowDevetiDivDrugiBox3'>
                                  <TextField
                      
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="donatId"
                    label="Donat ID"
                    variant="outlined"
                    value={donatID}
                    disabled
                    onChange={(event) => {
                      
                    }}
                  />
                </div>

            </div>

            {/*Osmi red*/}
            <div className='row-container'>
                <div className='classForSpecificRowDesetiDivPrviBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="nkdKodDonat"
                    label="NKD-Kod Donat"
                    variant="outlined"
                    value={NKD}
                    disabled
                    onChange={(event) => {
                      
                    }}
                  />
                </div>
                <div className='classForSpecificRowDesetiDivDrugiBox3'>
                                  <TextField
                      InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black'}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"


                    fullWidth
                    id="market"
                    label="Market"
                    variant="outlined"
                    value={market}
                    disabled
                    onChange={(event) => {
                  
                    }}
                  />
                </div>

            </div>

          </div>

          {/*BOTUNI*/}
          {/*
          <div className='button-card'>
            <div className='button-container'>
              <Button sx={{ height:"30px", fontSize: '10px' }}
                fullWidth
                variant="contained"
                onClick={() => {
                  updateTelefon()
                }}
               
              >
                Prihvati
              </Button>
            </div>
            <div className='button-container'>
              <Button sx={{ height:"30px", fontSize: '10px' }}
                fullWidth
                variant="contained"
                onClick={() => {
                  odustaniButtonFunction()
                }}
               
              >
                Odustani
              </Button>
            </div>
            <div className='button-container'>
              <Button sx={{ height:"30px", fontSize: '10px' }}
                fullWidth
                variant="contained"
                onClick={() => {
                  obrisiButtonFunction()
                }}
                
              >
                Obriši
              </Button>
            </div>
            <div className='button-container'>
              <Button sx={{ height:"30px", fontSize: '10px' }}
                fullWidth
                variant="contained"
                onClick={() => {
                  krajButtonFunction()
                }}
               
              >
                Kraj
              </Button>
            </div>

          </div>*/}

        </div>

      </div>
    </ThemeProvider>
  );

};

export default Telefoni;
